module.exports = __webpack_public_path__ + "img/blog-5.4bcb470c.jpg";